import { FC } from 'react'

import {
  Box,
  GreyGrey60,
  PreviewCard,
  Primary13Regular,
  Text
} from '@sequencehq/core-components'

import { recordAddressLines } from '../../integrationSyncErrorAddress'
import { syncErrorExternalUrl } from '../../integrationSyncErrorLink'
import { entityLabel, recordName } from '../../integrationSyncErrorMessages'
import { RecordAddressLine, SyncErrorTaskInput } from '../../types'
import { ViewInIntegrationAction } from '../../ViewInIntegrationAction'

const TEST_ID = 'watchtower.notification.integrationSyncError.recordCard'

export const CustomerRecordCard: FC<{
  taskId: string
  input: SyncErrorTaskInput
}> = ({ taskId, input }) => {
  const name = recordName(input)
  const addressLines = recordAddressLines(input)
  const hasRecordToShow = Boolean(name) || addressLines.length > 0
  const hasExternalLink = Boolean(syncErrorExternalUrl(input))

  if (!hasRecordToShow) {
    return null
  }

  return (
    <PreviewCard
      data-testid={TEST_ID}
      showBorder
      title={name ?? entityLabel(input.entityType)}
      subtitle={addressLines.map(line => (
        <AddressLine key={line.field} line={line} />
      ))}
      content={
        hasExternalLink ? (
          <Box mt="8px">
            <ViewInIntegrationAction
              taskId={taskId}
              fullWidth
              data-testid={`${TEST_ID}.viewInIntegration`}
            />
          </Box>
        ) : undefined
      }
    />
  )
}

const AddressLine: FC<{ line: RecordAddressLine }> = ({ line }) => (
  <Text
    {...Primary13Regular}
    lineHeight="18px"
    color={line.isPlaceholder ? GreyGrey60 : undefined}
    data-testid={`${TEST_ID}.addressLine`}
  >
    {line.text}
  </Text>
)
